import { delay } from '@superbet-group/web.lib.utilities';

export async function waitForSelector(
    selector: string,
    timeoutMs = 10_000,
    delayBetweenChecksMs = 100,
): Promise<HTMLElement | null> {
    const startTime = Date.now();
    const selectorWithEscapedDots = escapeDots(selector);
    while (Date.now() - startTime < timeoutMs) {
        const element = document.querySelector(selectorWithEscapedDots);
        if (element) {
            return element as HTMLElement;
        }

        // eslint-disable-next-line no-await-in-loop
        await delay(delayBetweenChecksMs);
    }

    return null;
}

function escapeDots(inputString: string) {
    const firstDotIndex = inputString.indexOf('.');

    return inputString.replace(/\./g, (match, index) => {
        return index > firstDotIndex ? '\\.' : '.';
    });
}

export function resolveFontProperties(el: HTMLElement): FontProperties {
    const style = window.getComputedStyle(el, null);

    return {
        fontSize: style.getPropertyValue('font-size'),
        fontWeight: style.getPropertyValue('font-weight'),
    };
}

export function measureTextWithCanvas(text: string, fontOpts: FontProperties): number {
    const canvasEl = document.createElement('canvas');
    const ctx = canvasEl.getContext('2d')!;

    const fontSizeFormatted = typeof fontOpts.fontSize === 'number'
        ? `${fontOpts.fontSize}px`
        : fontOpts.fontSize;
    ctx.font = `${fontOpts.fontWeight} ${fontSizeFormatted} Inter, sans-serif`;

    const displayedText = stripHtmlTags(text);

    return ctx.measureText(displayedText).width;
}

export function stripHtmlTags(text: string): string {
    if (typeof DOMParser === 'undefined') {
        return text; // Test context, Node doesn't have DOMParser
    }

    const parser = new DOMParser();
    return parser.parseFromString(text, 'text/html').body.textContent || '';
}

type FontProperties = {
    fontSize: number | string;
    fontWeight: number | string;
};
